import { useUserDevice } from './useUserDevice';

export const useMentorStatus = () => {
  const { currentUserIdentity, isLoading } = useUserDevice();
  
  // Check Convex identity (authoritative source)
  const identityLower = currentUserIdentity?.toLowerCase() || '';
  const isSelfManaged = identityLower === 'self-managed' || identityLower === 'selfmanaged';
  const isMentorByIdentity = ['mentor', 'parent', 'admin', 'supervisor', 'organization'].includes(identityLower);
  
  // Users who can directly change settings (not request)
  const canChangeDirectly = isSelfManaged || isMentorByIdentity;
  
  return { 
    isMentor: canChangeDirectly,  // For backward compatibility
    isSelfManaged,
    canChangeDirectly,
    isLoading 
  };
};
